import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import { Loader2 } from "lucide-react";

export default function QRCodeRouter() {
  const { boxNumber } = useParams<{ boxNumber: string }>();
  const navigate = useNavigate();
  const [isChecking, setIsChecking] = useState(true);

  useEffect(() => {
    const checkAuthAndRoute = async () => {
      if (!boxNumber) {
        navigate('/');
        return;
      }

      // Check if user is authenticated
      const { data: { session } } = await supabase.auth.getSession();

      if (session?.user) {
        // User is logged in, redirect to /box/new with box number pre-filled
        navigate(`/box/new?boxNumber=${boxNumber}`);
      } else {
        // User is not logged in, redirect to /try with box number
        navigate(`/try?boxNumber=${boxNumber}`);
      }
    };

    checkAuthAndRoute();
  }, [boxNumber, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="flex items-center gap-2">
        <Loader2 className="h-6 w-6 animate-spin" />
        <span>Redirecting...</span>
      </div>
    </div>
  );
}
